import style from "./stylesheets/Footer.module.scss";
import YSlash from "../resources/y_slash_white.png";

const Footer = () => (
    <div id={style.footer}>
        <a href="https://babel.hathitrust.org/cgi/pt?id=uc1.b4498567&seq=11">
            <img src={YSlash} alt="Yale Engineering Slash" />
        </a>
        <p>© Yale School of Engineering & Applied Science 2026.</p>
        <p>Website by Eric Yoon '27. Scavenger hunt designed by Eric Yoon '27 and Sophia Zhou '26</p>
        <p>Check this out: 978-1258443740</p>
    </div>
);

export default Footer;